import axios from "axios";
//import config from "../config/config.json"

export const getBooking = async (request,tokenClient,apiToken) => {

  let config = require(`../config/${tokenClient}/config.json`);

  const headers = {
    'Content-Type': "application/json",
    'token': apiToken
  };

  const url = config.credential.api.url+'booking/create';

  const response = await axios.post(url,JSON.stringify(request),{headers:headers})
  //const response = await axios.post(url)
    .then(res => {

      if(config.credential.retrieveBooking && config.credential.retrieveBooking.active){
        let userName = sessionStorage?.getItem('userName') ? sessionStorage?.getItem('userName') : null;
        retrieveBooking(config.credential.retrieveBooking, res.data, userName)
      }
       

      return res;
    })
    .catch((err) => {

      return false;
    }); 
   
  return response;
}


const retrieveBooking = (credential, responseBooking, userName) =>{

  const headers = {
    'Content-Type': "application/json",
    'token': credential.token
  };
  let request = {
    "userName": userName,
    "bookingReference":responseBooking.bookingReference,
    "status": responseBooking.bookingStatus,
    "hash":responseBooking.hash
    }
  const url = credential.url;

  const response = axios.post(url,JSON.stringify(request),{headers:headers})

}